export default {
    parts: [
        'wrapper',
        'container',
        'topRow',
        'logoLink',
        'logo',
        'desktopProgressWrapper',
        'mobileProgressWrapper',
        'iconsGroup',
        'iconButton'
    ],
    baseStyle: () => ({
        wrapper: {
            px: {base: 4, lg: 6},
            mb: {base: 0, lg: 8},
            bg: 'webTheme.backgroundDefault'
        },
        // The main header row.
        // Mobile: 3-column flex so the logo can be perfectly centred while
        // icons stay on the right. We use invisible flex-1 spacer on the left.
        // Desktop: normal flex row, logo left, progress bar centre, icons right.
        topRow: {
            position: 'relative',
            alignItems: {base: 'center', lg: 'flex-start'},
            justifyContent: 'space-between',
            minHeight: {base: '48px', lg: '75px'},
            mb: {base: 6, lg: 0},
            py: {lg: 3},
        },
        // Logo link: absolutely centred on mobile, static on desktop
        logoLink: {
            position: {base: 'absolute', lg: 'static'},
            left: {base: '50%', lg: 'auto'},
            transform: {base: 'translateX(-50%)', lg: 'none'},
            flexShrink: 0
        },
        logo: {
            w: '109px',
            height: 'auto',
            display: 'block'
        },
        // Progress bar wrapper: hidden on mobile (shown in its own row below),
        // visible as a centred flex-1 section on desktop
        desktopProgressWrapper: {
            display: {base: 'none', lg: 'flex'},
            flex: '1',
            justifyContent: 'center'
        },
        // Separate progress bar row shown only on mobile, below the top row
        mobileProgressWrapper: {
            display: {base: 'flex', lg: 'none'},
            justifyContent: 'center',
            mb: {base: 5, lg: 9}
        },
        // Right-side icons cluster
        iconsGroup: {
            alignItems: 'center',
            gap: {base: 3, lg: 2},
            // On mobile: keeps a minimum left-side spacer so the logo is truly
            // centred. We rely on the absolute-positioned logo for centering.
            ml: {base: 'auto', lg: 0}
        },
        iconButton: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    })
}
